// ============================================
// モジュール読み込み
// ============================================
import { viewport } from "./libs/switchViewport";
import { inViewAnm, lenisPageScroll, topBtnAnm } from "./libs/Scroll";
import { drawer, fixedHeader, megaMenu } from "./libs/Header";
import { addAutoFunc, confirmForm } from "./libs/Form";
import { accordionFunc } from "./libs/Accordion";
import { archiveDropdown } from "./libs/Dropdown";
import { hospitalSearch } from "./libs/Search";
import { loadTotalCount } from "./libs/TotalCount";
// import { createIndex } from './libs/CreateIndex';
// import { numKeyFunc } from './libs/Form';
// import { articleTable, ScrollHintFunc } from './libs/ScrollHint';
import { modal } from "./libs/Modal";
import { topMap } from "./libs/Top";
// import { slider } from './libs/Slider';
// import { tabFunc } from './libs/Tab';

// 実行
// ==========================
window.addEventListener("DOMContentLoaded", () => {
  viewport();
  fixedHeader();
  drawer();
  megaMenu();
  // createIndex();
  addAutoFunc();
  lenisPageScroll();
  confirmForm();
  accordionFunc();
  archiveDropdown();
  hospitalSearch();
  loadTotalCount();
  topMap();
  // numKeyFunc();
  // articleTable();
  // ScrollHintFunc();
  // tabFunc();
});

window.addEventListener("load", () => {
  document.body.classList.add("is-loaded");
  inViewAnm();
  topBtnAnm();
  modal();
  // slider();
});
